import { DocumentProcessingJob } from '@/models/DocumentProcessingJob';
import { apiClient } from '@/services/api';
import { logger } from '@/utils/logger/loggerInstance';

export const getDocumentProcessingJob = async (jobId: string) => {
  const url = `/document-processing-jobs/${jobId}`;

  logger.debug(`GET ${url}`);
  const response = await apiClient.get<DocumentProcessingJob>(url);

  return response.data;
};

export const searchDocumentProcessingJobsByProperty = async (propertyId: string) => {
  const url = `/document-processing-jobs/search?propertyId=${propertyId}`;

  logger.debug(`GET ${url}`);
  const response = await apiClient.get<DocumentProcessingJob[]>(url);

  return response.data;
};

export const searchDocumentProcessingJobsByUser = async (userId: string) => {
  const url = `/document-processing-jobs/search?userId=${userId}`;

  logger.debug(`GET ${url}`);
  const response = await apiClient.get<DocumentProcessingJob[]>(url);

  return response.data;
};
